<template>
  <div class="wrapper">
    <el-dialog title="实名认证" :visible.sync="dialogVisible" width="500px" :before-close="close">
      <el-form ref="formData" :model="formData" label-width="0px">
        <el-form-item style="text-align: center;">
          <ImgUpload
            :upload-config="{ lebal: '实名认证照片', prefix: 'peopleImg', form: formData, suffix: '', modal: false }"
          />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="close">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { faceVerify } from "@/api/driver";
import ImgUpload from "@/components/ImgUpload";
export default {
  components: {
    ImgUpload,
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        peopleImg: '',
        partyCode: '',
      },
    };
  },
  created() {},
  methods: {
    show(partyCode,peopleImg) {
      this.formData.partyCode = partyCode
      this.formData.peopleImg = peopleImg || ''
      this.dialogVisible = true;
    },
    submit() {
      this.$refs["formData"].validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let response = await faceVerify(this.formData)
          rLoading.close()
          this.$message.success(response.msg);
          this.$emit("onSuccess");
          this.dialogVisible = false;
        }
        // else {
        //   this.$message.error("必选项为空或格式不正确");
        // }
      });
    },
    // 关闭
    close() {
      this.$refs.formData.resetFields();
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped lang='scss'>
</style>
